let saveSizeHtml;
let current = 0;
let evntLsnrAdded = false;

const handleSizeBtnPlacement = (my_interval) => {
  const best_fit_size_chart =
    document.querySelector(".ks-chart-container") || saveSizeHtml;
  const variant_swatch_king = document.querySelector("variant-swatch-king");

  if (best_fit_size_chart && variant_swatch_king) {
    let targetElement =
      variant_swatch_king.querySelector("#swatch-option2 legend label") ||
      variant_swatch_king.querySelector("#swatch-option1 legend label");

    if (targetElement) {
      if (!targetElement.querySelector(".ks-chart-container")) {
        targetElement.appendChild(best_fit_size_chart);
      }
      my_interval && clearInterval(my_interval);
      saveSizeHtml = best_fit_size_chart;
      if (!evntLsnrAdded) {
        evntLsnrAdded = true;
        variant_swatch_king.addEventListener("click", handleSizeBtnPlacement);
      }
    }
  } else if (current > 10) {
    my_interval && clearInterval(my_interval);
  }

  current++;
};

const move_size_btn = () => {
  const my_interval = setInterval(() => {
    handleSizeBtnPlacement(my_interval);
  }, 1000);
};

move_size_btn();
